import React from 'react';
import { FieldArray } from 'formik';
import { Button } from '@rsos/components/capstone/base';
import { Checkbox } from '../../common.styles';
import {
  AccordionRow,
  AccessPageContentRowText,
} from './PermissionAccordionContent.styles';

const PermissionAccordionContent = ({
  allPermissions,
  values,
  onCheckBoxChange,
  type,
  disabled,
  deselectAll,
  isSelectAll,
  selectAll,
}) => {
  return (
    <>
      {!!selectAll && (
        <AccordionRow>
          <Button
            btnType="secondary"
            type="button"
            size="small"
            dataName={isSelectAll ? 'role-deselect-all' : 'role-select-all'}
            onClick={isSelectAll ? deselectAll : selectAll}
            grow
            noMargin
          >
            {isSelectAll
              ? 'Disable all data sources'
              : 'Enable all data sources'}
          </Button>
        </AccordionRow>
      )}
      <FieldArray name={type}>
        {arrayHelpers => (
          <div
            id="access-control-checkbox-group"
            aria-labelledby="access-control-checkbox-group"
            role="group"
          >
            {allPermissions.map(permission => (
              <AccordionRow key={permission.name}>
                <Checkbox
                  type="checkbox"
                  data-name={permission.name}
                  name={permission.name}
                  checked={!!values.find(p => p === permission.name)}
                  value={permission.name}
                  disabled={disabled}
                  onChange={e =>
                    onCheckBoxChange(e, arrayHelpers, permission, values)
                  }
                />
                <AccessPageContentRowText
                  isGrayedOut={values.indexOf(permission.name) < 0}
                >
                  {permission.display_name}
                </AccessPageContentRowText>
              </AccordionRow>
            ))}
          </div>
        )}
      </FieldArray>
    </>
  );
};

export default PermissionAccordionContent;
